export const title = 'Chat-Tonic | Atención al cliente'
export const baseURL = '/manager'
